module.exports = __webpack_public_path__ + "img/plan.d351c7a8.webp";